import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';
import { LoadingOverlayComponent } from './loading-overlay.component';
import { GlobalLoadingOverlayComponent } from './global-loading-overlay.component';

@NgModule({
  imports: [CommonModule, TranslateModule],
  declarations: [GlobalLoadingOverlayComponent, LoadingOverlayComponent],
  exports: [GlobalLoadingOverlayComponent, LoadingOverlayComponent],
})
export class LoadingOverlayModule {}
